import {AxiosInstance} from "axios";
import {LiveServiceOffer} from "@/live/interfaces";

const LiveServiceResource = (client: AxiosInstance) => {
    return {
        /**
         * Get the Apodis Live version offered to this pharmacy.
         */
        async offer(): Promise<LiveServiceOffer> {
            return client.get("connect/live-service")
                .then((response) => response.data.data);
        }
    };
};

export default LiveServiceResource;
